import Page from 'components/Page';
import React, {Component} from 'react';
import {
  Col,
  Row,
} from 'reactstrap';

import Confirmar from '../components/ModalConfirmar'; 
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from 'utils/constants';
import Cargando from './../components/Cargando';


import {MdBookmark, MdAccountBox} from 'react-icons/md';
import Utils from './../utils/utils'; 


import ModalPostulacion from './../components/ModalPostulacion';
import TablaPostulacion from './../components/TablaPostulacion';

import Postulacion from './../api/Postulacion'; 
import Usuario from './../api/Usuario'; 
import Estudiante from './../api/Estudiante';
import Correo from './../api/Correo';

const correo = new Correo(); 
const est = new Estudiante(); 
const usuario = new Usuario(); 
const postulacion = new Postulacion(); 



class Postulaciones extends Component {

    constructor() {
        super();
        this.state = {
 
            listado:[],
            postulacion:{}, 
            estado:'',
            mostrarGuardar:false,
            ciclo:'',
            confirmar:false,
            cargando:true,
        }
    }


    toggleModal = () => {
        this.estadoDefault();
        this.setState(prevState => ({
          modal: !prevState.modal
        }));


    
    }

    estadoDefault = () => {
        this.setState({
            postulacion:{}, 
            estado:'',
            mostrarGuardar:false,
            ciclo:'',
            confirmar:false,
            cargando:false,

        })
    }

    muestraConfirmar = () => {
        this.setState(prevState => ({
            confirmar: !prevState.confirmar
        })); 

    }

    infoPostulacion = (postulacion) =>{
        this.setState({postulacion:postulacion, estado: postulacion.estado})
    }


    listadoPostulaciones = async () => {
        let listado = await postulacion.mostrar(); 
        this.setState({listado : listado, cargando:false});
      
    }

    manejaEstado = (e) => {
         
        if(e.target.value==='Aceptada'){
            this.setState({estado: e.target.value, mostrarGuardar:false, ciclo:''}); 
            
        } else {
            this.setState({estado: e.target.value, mostrarGuardar:true}); 
        }

    }

    manejaCiclo = (e) => {

        if(e.target.value!=='Seleccione'){
            this.setState({ciclo: e.target.value, mostrarGuardar:true}); 
        } else {
            this.setState({ciclo: e.target.value, mostrarGuardar:false}); 
        }
        
    }

    componentDidMount(){
        this.listadoPostulaciones();     

    }


    cambiarEstado = async () => {
        const {estado} = this.state;
        let respuesta = await postulacion.editar(this.state.postulacion.id, estado); 

        if(estado==="Aceptada"){
            this.guardarEstudiante();

            setTimeout(() => {
                this.notificationSystem.addNotification({
                    title: <MdAccountBox />,
                    message: 'Estudiante registrado con exito',
                    level: 'success',
                    position:'tr'
                });
              }, 1500);

        }

        if(respuesta==="ok"){
        
            this.listadoPostulaciones();

            this.notificationSystem.addNotification({
                title: <MdBookmark />,
                message: 'Estado de postulante cambiado',
                level: 'info',
                position:'tr'
              });
          

        }else {
            this.Notificaciones.addNotification({
                message: 'se produjo un error vuelva a intentarlo',
                level: 'error',
                position:'tr'
            });  
        }


        this.toggleModal();


    }

    guardarEstudiante = () => {
        const {postulacion, ciclo} = this.state;

        const {nombres, apellidos, rut, telefono, email, direccion, comuna} = postulacion; 

        let pass = Utils.simpleEncode(rut); 
        
        this.ingresarUsuario(rut, pass, nombres, apellidos, email, 3, direccion, comuna, telefono); 
        this.ingresarEstudiante(rut, ciclo); 

        this.correoEstudianteIngresado(rut, pass, email, nombres, apellidos); 

    }


    ingresarUsuario = async (id, pass, nombres, apellidos, email, tipo, direccion, comuna, telefono) => {
          
        let resultado = await usuario.ingresar(id, pass, nombres, apellidos, email, tipo, direccion, comuna, telefono); 

        if(resultado==="ok"){
            console.log("usuario ingresado")
        }else {
            console.log(resultado);
            
        }

    }


    ingresarEstudiante = async (estudiante, ciclo) => {
                    
        let resultado = await est.ingresar(estudiante, ciclo); 
    
        if(resultado==="ok"){console.log("estudiante ingresado")}
    
      }

    correoEstudianteIngresado = async (usuario_id, password, email, nombres, apellidos) =>{
        let resultado = await correo.ingresoEstudiante(usuario_id, password, email, nombres, apellidos); 
        if(resultado==="ok"){
            console.log("correo enviado");
            
        }else {
            console.log(resultado);
        }
    }
    

    render(){
        const {listado, modal, postulacion, estado, mostrarGuardar, ciclo, confirmar, cargando} = this.state;
        return (
            <Page title="Postulaciones" breadcrumbs={[ { name: 'Postulaciones', active: true } ]}>
        
                <Cargando valor={cargando}/>
                <Row className="no-margin-bottom">

                    <Col className="no-margin-bottom">
                        <TablaPostulacion 
                            listado={listado}
                            toggleModal={this.toggleModal}
                            postulacion={this.infoPostulacion}
                        />               
                    
                    </Col>

                </Row>


                <ModalPostulacion 
                    isOpen={modal} 
                    toggle={this.toggleModal} 
                    postulacion={postulacion}
                    estado={estado}
                    manejaEstado={this.manejaEstado}
                    mostrarGuardar={mostrarGuardar}
                    manejaCiclo={this.manejaCiclo}
                    ciclo={ciclo}
                    confirmar={this.muestraConfirmar}
                 
                />

                <Confirmar 
                    isOpen={confirmar} 
                    toggle={this.muestraConfirmar} 
                    texto={"¿Esta seguro de cambiar el estado de postulación a "+estado+" ?"} 
                    funcion={this.cambiarEstado} 
       
                />


                <NotificationSystem
                    dismissible={false}
                    ref={notificationSystem =>
                        (this.notificationSystem = notificationSystem)
                    }
                    style={NOTIFICATION_SYSTEM_STYLE}
                    />
        
            </Page>



          );
    }
 
};

export default Postulaciones;
